import { FormGroup, FormBuilder } from "@angular/forms";

export class M_STORE_TIME {
    no: number = 0;

    hQ_CD: string = '';
    stR_CD: string = '';

    day: string = '';
    daY_NM: string = '';

    timE_TP: string = '';
    timE_TP_NM: string = '';

    timE_SEQ: number = 0;

    starT_TIME: any; // ex: "0800"
    enD_TIME: any;   // ex: "2100"

    remark: string | null = null;
    usE_YN: string = 'Y';
    isUse: boolean = false;

    inserT_DT: Date | null = null;
    inserT_USER: string | null = null;
    updatE_DT: Date | null = null;
    updatE_USER: string | null = null;

    newFG: boolean = false;

    breakTimes: M_STORE_TIME[];

    constructor(init?: Partial<M_STORE_TIME>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];
            if (
                (key === 'starT_TIME' || key === 'enD_TIME') && value
            ) {
                const date = new Date(value);

                const hh = String(date.getHours()).padStart(2, '0');
                const mm = String(date.getMinutes()).padStart(2, '0');

                obj[key] = `${hh}${mm}`;
            }
            else if (key === 'breakTimes') {
                obj[key] = value.map((bt: any) => {

                    const breakObj: any = {};

                    Object.keys(bt).forEach(bk => {

                        const breakValue = bt[bk];

                        if ((bk === 'starT_TIME' || bk === 'enD_TIME') && breakValue) {

                            const date = new Date(breakValue);
                            const hh = String(date.getHours()).padStart(2, '0');
                            const mm = String(date.getMinutes()).padStart(2, '0');

                            breakObj[bk] = `${hh}${mm}`;
                        }
                        else {
                            breakObj[bk] = breakValue ?? null;
                        }

                    });

                    return breakObj;
                });
            }
            else {
                obj[key] = value ?? null;
            }
        });

        return obj;
    }

    fromJSON(json: any): M_STORE_TIME {
        return new M_STORE_TIME({
            ...json,
            inserT_DT: this.parseISODate(json?.inserT_DT),
            updatE_DT: this.parseISODate(json?.updatE_DT)
        });
    }

    getAll(res: any[]): M_STORE_TIME[] {
        return (res ?? []).map(e => {
            const model = this.fromJSON(e);

            model.starT_TIME = this.formatTime(model.starT_TIME);
            model.enD_TIME = this.formatTime(model.enD_TIME);

            return model;
        });
    }


    createForm(fb: FormBuilder): FormGroup {
        return fb.group({
            hQ_CD: [''],
            stR_CD: [''],
            day: [''],
            daY_NM: [''],
            timE_TP: [''],
            timE_TP_NM: [''],
            timE_SEQ: [0],
            starT_TIME: [''],
            enD_TIME: [''],
            remark: [null],
            usE_YN: ['Y']
        });
    }

    /** yyyyMMddHHmmss */
    formatDateTime(dateString: string): string {
        const date = new Date(dateString);

        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${y}${m}${d}${hh}${mm}${ss}`;
    }

    parseISODate(value: string): Date | null {
        if (!value) return null;
        return new Date(value);
    }

    formatTime(num: string): Date | null {
        if (!num) return null;

        const time = num.padStart(4, '0');

        const hour = Number(time.substring(0, 2));
        const minute = Number(time.substring(2, 4));

        const now = new Date();
        now.setHours(hour, minute, 0, 0);

        return now;
    }

    /** "08:00" -> "0800" */
    parseHHmmToString(time: string): string {
        if (!time) return '';
        return time.replace(':', '');
    }
}